 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Account No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryAcctNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryAcctNoFilterForm"
                            v-model="filtersAcctNo.accountNo"
                            :label="filtersAcctNoLabel.accountNo"
                            :error-messages="errors.collect('filterAcctNo')"
                            data-vv-name="filterAcctNo"
                            :data-vv-as="filtersAcctNoLabel.accountNo"
                            v-validate="'entry|max:8'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearAcctNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doAcctNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="acctNoHeaders"
          :items="acctNoItems"
          v-bind:options.sync="paginationAcctNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsAcctNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.inter }}</td>
              <td>{{ row.item.name }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignAcctNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { creditNoteFilterMixin } from '@/mixins/accounting/creditNote/creditNoteFilterMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationAcctNo: {
        page: 1
      }
    }
  },
  mounted() {
    this.doClearAcctNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersAcctNo.accountNo = ''
      this.$emit('close')
    },
    doClearAcctNoFilters() {
      this.filtersAcctNo.accountNo = ''
      this.fetchCrAcctNoData()
    },
    doAcctNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryAcctNoFilterForm').then((result) => {
        if (result) {
          this.paginationAcctNo.page = 1
          this.fetchCrAcctNoData()
        }
      })
    },
    assignAcctNo(data) {
      this.$emit('assign-acct-no', data.inter)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, creditNoteFilterMixin, commonAjaxMixin]
}
</script>
